/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   For when you're not sure whether you're on a detail page
 */

import { event } from '@zcode-ui/web-zumper-integrations'
import type { User } from '@zcode/bizos'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import { checkDetailView } from '../../../inspectors/index'
import type { Dispatch } from '../../types'
import { type TrackDetailEventProps, trackDetailEvent } from './trackDetailEvent'

interface TrackMightBeDetailEventProps extends TrackDetailEventProps {
  user?: User
}

/**
 * `trackDetailEvent(...)`, when called on a detail page, adds a bunch of detail-page-specific
 * data (crucially, `pageType: "Building"` or `pageType: "New Building"`) to the traktor event,
 * then calls `event(...)` with the enhanced traktor event. If called from a **non-detail** page,
 * it drops the tractor event and sends nothing 😞
 *
 * `trackMightBeDetailEvent(...)` checks whether we're on a detail page. If we are, it calls
 * `trackDetailEvent(...)`, so that we get that extra data in there. Otherwise, it just calls
 * `event(...)`
 *
 * @param props
 */
export const trackMightBeDetailEvent = (props: TrackMightBeDetailEventProps) => {
  return (dispatch: Dispatch) =>
    checkDetailView(dispatch(getRouteProps()))
      ? dispatch(trackDetailEvent(props))
      : dispatch(event(props.additionalProps ? { ...props, props: props.additionalProps } : props))
}
